<template>
  <div>
    <div class="find">
      <div class="seach-top">
        <el-table
          class="table-list"
          :border="true"
          :data="tableData"
          style="width: 100%"
          @sort-change="handleResort"
        >
          <!-- 序号 -->
          <el-table-column label="序号" type="index" width="50px" align="right" />

          <el-table-column label="投递时间" prop="sendDT" width="170px">
            <template slot-scope="scope">
              <span>{{ scope.row.sendDT |dateTimeFmt }}</span>
            </template>
          </el-table-column>
          <el-table-column label="姓名" prop="userInfo.name" width="150px" :show-overflow-tooltip="true" />
          <el-table-column label="性别" prop="userInfo.sexDictIdItemName" width="60px" />
          <el-table-column label="民族" prop="userInfo.minZu" width="120px" :show-overflow-tooltip="true" />
          <el-table-column label="单位名称" prop="userInfo.danWeiMingCheng" width="250px" :show-overflow-tooltip="true" />
          <el-table-column label="部门" prop="userInfo.buMen" width="150px" :show-overflow-tooltip="true" />
          <el-table-column label="科室" prop="userInfo.keShi" width="150px" :show-overflow-tooltip="true" />
          <el-table-column label="研究领域" prop="userInfo.yanJiuLingYu" width="200px" :show-overflow-tooltip="true" />
          <el-table-column label="所属学科" prop="userInfo.suoShuXueKe" width="200px" :show-overflow-tooltip="true" />
          <el-table-column label="研究方向" prop="userInfo.yanJiuFangXiang" width="200px" :show-overflow-tooltip="true" />

          <el-table-column fixed="right" label="备注" prop="remark" width="250px" :show-overflow-tooltip="true" />
          <el-table-column
            fixed="right"
            label="操作"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <span>
                <el-button type="text" size="mini" plain @click.stop="handleEditRemark( scope.row,scope.$index)">备注</el-button>
                <el-button type="text" size="mini" plain @click.stop="handleViewJianli( scope.row)">查看简历</el-button>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next,total,sizes"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          :total="totalCount"
          @size-change="handleSizeChange"
          @current-change="handleChangePage"
        />

      </div>
    </div>
    <!-- 简历展示 -->
    <Resume
      v-model="resumeShow"
      :resume-user-id="resumeUserId"
      :resume-key="resumeKey"
    />

  </div>
</template>
<script>
import pathReq from '@/api/pathlist'
import KxjCom from '@/utils/kxjcom'
import Resume from '@/components/Resume'
// import viewpage from './recruit-view'
export default {
  components: { Resume },
  filters: {
    dateTimeFmt(val) {
      return KxjCom.tableDateTimeFormat(val)
    }
  },
  // components: { viewpage },
  data() {
    return {
      recruitId: null,
      tableHeader: [],
      totalCount: 0,
      tableData: [],
      searchForm: {
        keyWord: '',
        pageNumber: 1,
        pageSize: 10,
        sortKey: '',
        sortOrder: ''
      },
      dtlKey: null,
      // 简历数据
      resumeShow: false,
      resumeUserId: null,
      resumeKey: null

    }
  },
  activated() {
    this.handleSearch()
  },
  mounted() {
    this.recruitId = this.$route.params.recruitId
  },
  methods: {
    /** 点击我的发布 */
    handleToMyPublish() {
      this.$router.push('/gr/gr0702')
    },
    // 每页
    handleSizeChange(val) {
      this.searchForm.pageSize = val
      this.handleSearch()
    },
    // 切页
    handleChangePage(page) {
      this.searchForm.pageNumber = page
      this.handleSearch()
    },
    // 排序
    handleResort(column) {
      this.searchForm.sortKey = column.prop
      this.searchForm.sortOrder = column.order
      this.handleSearch()
    },
    /** 查询 */
    handleSearch() {
      const that = this
      const loading = this.$loading(KxjCom.loadOptions)
      const path = '/api/services/app/GR07/GetGR07sSendList?id=' + this.recruitId
      pathReq
        .getNoParams(path)
        .then(res => {
          loading.close()
          that.tableData = res.data.result
        })
    },
    /** 详情 */
    handleEditRemark(row, rowIdx) {
      const that = this
      this.$prompt('', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputValue: row.remark
      }).then(({ value }) => {
        const path = '/api/services/app/GR07/Gr07SendDoRemark'

        const formData = {
          id: row.id,
          remark: value
        }
        pathReq
          .dataUpdate(path, formData)
          .then(res => {
            that.$message.success('保存成功')
            that.handleSearch()
          })
      })
    },
    /** 查看简历 */
    handleViewJianli(row) {
      this.resumeUserId = row.userInfo.userId
      this.resumeShow = true
    }
  }

}
</script>
<style scoped>

h5 {
  margin: 15px 0;
  padding-left: 6px;
  border-left: 3px solid #b8dbec;
}

.el-textarea__inner{
  height:300px;
}

textarea{
  height:300px;
}
</style>
